import { COLORS } from '@alto/design-library-tokens';
import { Description, MdSpacing, Row } from '@alto/design-system';
import React from 'react';
import { StyleSheet } from 'react-native';
import { PRICE_FREE, PRICE_PENDING } from '~shared/features/pricing/constants';
import { getFormattedPrice, isTotal, shouldBeSemibold } from '~shared/helpers/pricingBreakdown';
import { PricingInfoLabel } from './PricingInfoLabel';

type Props = {
  readonly label: string;
  readonly onPressChange?: () => void;
  readonly onPressMoreInfo?: () => void;
  readonly originalPrice?: number | null;
  readonly price: number | string | null | undefined;
  readonly savings?: boolean;
};

export const PricingInfoRow = ({ onPressMoreInfo, label, onPressChange, originalPrice, price, savings }: Props) => {
  const formattedPrice = getFormattedPrice(price, savings);
  const formattedOriginalPrice = getFormattedPrice(originalPrice || 0);
  const isTotalPrice = isTotal(label);
  const semibold = shouldBeSemibold(label);
  const fontFamily = semibold ? 'semibold' : undefined;

  const priceTextColor = (() => {
    if (price === PRICE_FREE || savings) {
      return COLORS.TEXT_COLORS.SUCCESS;
    }
    if (price === PRICE_PENDING || isTotalPrice) {
      return COLORS.TEXT_COLORS.PRIMARY;
    }
    return COLORS.TEXT_COLORS.GREY;
  })();

  const styles = StyleSheet.create({
    priceLabelRow: {
      flex: 1,
    },
  });

  return (
    <Row spaceBetween>
      <Row style={styles.priceLabelRow}>
        <PricingInfoLabel
          label={label}
          semibold={semibold}
          priceTextColor={priceTextColor}
          onPressChange={onPressChange}
          onPressMoreInfo={onPressMoreInfo}
        />
      </Row>
      <MdSpacing />
      {originalPrice && price === PRICE_FREE ? (
        <Row>
          <Description
            textDecorationLine="line-through"
            fontFamily={fontFamily}
          >
            {formattedOriginalPrice}
          </Description>
          <Description
            fontFamily={fontFamily}
            color={priceTextColor}
          >{` ${formattedPrice}`}</Description>
        </Row>
      ) : (
        <Description
          fontFamily={fontFamily}
          color={priceTextColor}
        >
          {formattedPrice}
        </Description>
      )}
    </Row>
  );
};
